exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".basic-container {\n  padding: 16px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background: #f0f2f5;\n  min-height: calc(100vh - 96px);\n}", ""]);

// exports
